import { useHistory } from "react-router";

function EventDay({ event }) {
  const history = useHistory();

  let cancelledEvent = event && event.status == "canceled" ? true : false;

  return (
    <div
      onClick={() => history.push("/my-appointments/" + event.id)}
      className="border-l-4 border-indigo-600 p-2 flex items-center overflow-auto shadow"
    >
      <div
        style={{ color: "grey" }}
        className="mr-1 rounded-full h-35 w-35 pr-1 ml-1"
      >
        <img
          src={ event.profile_pic ? event.profile_pic : "/avator.png"}
          height={40}
          width={40}
          alt="avator"
          className="rounded-full"
        />
      </div>
      <div>
        <div
          className={`font-bold ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary "
          }`}
        >
          {event.name}
        </div>
        <div
          className={`text-xs font-bold opacity-50 ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary"
          }`}
        >
          {new Date(event.start).toLocaleDateString("en-us", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
        <div
          className={`text-xs font-bold opacity-50 ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary"
          }`}
        >
          {event.clinic}
        </div>
      </div>
      <div className="ml-5 mr-4">
        <span className="text-xs text-secondary font-bold opacity-50 bg-gray-200 rounded p-2">
          Requested
        </span>
      </div>
    </div>
  );
}

export default EventDay;
